import React from 'react';
import { Handle } from 'rc-slider';

import styles from './slider-tooltip.scss';

interface SliderTooltipProps {
  index: number;
  value: number;
}

function SliderTooltip(props: SliderTooltipProps) {
  const { index, value, ...rest } = props;

  return (
    <Handle
      className={styles['container']}
      key={index}
      {...rest}
      dragging={value.toString()}
    >
      <span className={value > 10 ? styles['tooltip'] : styles['tooltip-left']}>
        {value}k
      </span>
    </Handle>
  );
}

export default SliderTooltip;
